// extracted by mini-css-extract-plugin
export default {"box":"TextUI_box__cGvwG","input":"TextUI_input__dKoQu","error":"TextUI_error__JwloK"};